import { useState, useEffect, useContext } from 'react';
import { GET_FLASHCARDS, GET_ACRONYMS, GET_GLOSSARY } from "../api/content";
import { BundleContext } from "../context/BundleProvider";

export const useFeatureFlags = () => {
  const { selectedCertificate } = useContext(BundleContext);
  const [isGlossary, setIsGlossary] = useState(false);
  const [isAcronyms, setIsAcronyms] = useState(false);
  const [isFlashcards, setIsFlashcards] = useState(false);

  useEffect(() => {
    const GLOSSARY = GET_GLOSSARY(selectedCertificate);
    const ACRONYMS = GET_ACRONYMS(selectedCertificate);
    const FLASHCARDS = GET_FLASHCARDS(selectedCertificate);
    // Check if features are available
    setIsGlossary(GLOSSARY?.length ? true : false);
    setIsAcronyms(ACRONYMS?.length ? true : false);
    setIsFlashcards(FLASHCARDS?.length ? true : false);
  }, []);

  return {
    isGlossary,
    isAcronyms,
    isFlashcards
  };
}; 